﻿import $ from 'jquery';
import _ from 'underscore';

declare global {
  interface JQuery {
    fileinput: () => any;
  }
}
export class FileInput {
  static get wireup(): string {
    return '[data-fileinput]';
  }

  static get inputFlag(): string {
    return FileInput.wireup;
  }
  static get preserveFlag(): string {
    return '[data-fileinput-preserve]';
  }
  static get handledFlag(): string {
    return 'fileinput-handled';
  }

  public static get droppedFile(): File { return this._droppedFiles ? FileInput.droppedFiles[0] : null; }
  private static _droppedFiles: Array<File>;
  public static get droppedFiles(): Array<File> { return FileInput._droppedFiles; }

  public static storeDroppedFile(data: IHaveDroppedFile): void {
    FileInput.storeDroppedFiles([data.file]);
  }

  public static storeDroppedFiles(files: Array<File>): void {
    this._droppedFiles = files;
  }

  public static stagedFiles: any = {};
  public static addStagedFile(data: FileInputInfo): void {
    FileInput.stagedFiles[data.elementId] = data;
  }

  public static handleStagedFiles($context: JQuery): void {
    if ($context.data(FileInput.handledFlag)) {
      return;
    }

    if ($context.find(FileInput.preserveFlag).length == 0) {
      FileInput.clearStagedFiles();
    }
    FileInput.setInputs();

    $context.data(FileInput.handledFlag, "handled!");
  }

  public static clearStagedFiles(): void {
    FileInput.stagedFiles = {};
  }

  public static setInputs(): void {
    for (var key in FileInput.stagedFiles) {
      var fileInfo = <FileInputInfo>FileInput.stagedFiles[key];
      try {
        (<any>$(fileInfo.selector)[0]).files = fileInfo.fileData;
      }
      catch (e) {
        // some browsers do not support setting the files collection yet.
      }
    }
  }

  constructor() {
    FileInput.wireupDocument();
  }

  private static wireupDocument: Function = _.once(() => {
    $(document).on('change.rustig.fileinput', FileInput.inputFlag, function (e) {
      var $input = $(e.target);
      var elementId = $input.attr('id');
      var fileData = (<any>$input[0]).files;
      FileInput.addStagedFile(new FileInputInfo(fileData, elementId));
    });
  });
}

export interface IHaveDroppedFile {
  file: File;
}

export class FileInputInfo {
  constructor(public fileData: any, public elementId: string) { }

  get selector(): string {
    return "#" + this.elementId;
  }
}

function Plugin() {
  var $this = this;
  return $this.each(function () {
    FileInput.handleStagedFiles($(this).closest('form'));
  });
}

$.fn.fileinput = Plugin;
